const itemSstyle = {
  display: "flex",
  flexDirection: "column",
  border: "1px solid #ccc",
  borderRadius: "5px",
  padding: "15px",
  width: "50%",
  margin: "10px auto",
  backgroundColor: "#f9f9f9",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
};

const optionListStyle = {
  listStyle: "none",
};

const AddonItem = ({ item }) => {
  return (
    <div style={itemSstyle}>
      <h3 className="massage-title">
        {item.title} ${item.price}
      </h3>
      <p className="massage-description">{item.description}</p>
      {item.options && (
        <>
          <br />
          <ul style={optionListStyle}>
            {item.options.map((option, index) => (
              <li key={index}>
                <span className="bold">{option.title}:</span>
                <span>{option.description}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default AddonItem;
